import { MemberAccount } from "../../domain/models/MemberAccount";
import { MembershipLevel } from "../../domain/models/MembershipLevel";

export interface MemberAccountSummaryCardProps {
  memberAccount: MemberAccount;
  membershipLevel?: MembershipLevel;
}

export const MemberAccountSummaryCard = ({
  memberAccount,
  membershipLevel
}: MemberAccountSummaryCardProps) => {

  return (
    <div className="member-account-summary-card">
      <div style={{ marginBottom: '1rem' }}>
        Oi{memberAccount?.name ? <span>, <strong>{memberAccount?.name}</strong></span> : null}! <br/>
        {memberAccount?.email}
      </div>
       <div>
        nível atual: {memberAccount?.membershipLevelId} - {membershipLevel?.name} <br/>
        pontos disponíveis: {memberAccount?.pointsBalance || 0}
      </div>
    </div>
  )
}